<template>
  <div>
    <Row :gutter="10">
      <i-col :md="24" :lg="24" style="margin-bottom: 10px;">
        <Card>
          <div class="search-con search-con-top">
            <Input class="search-input" v-model="searchVal" style="padding:5px;" placeholder="输入路径搜索"
                   @on-enter="searchinput"/>
            <Button type="primary" @click="searchinput" class="search-btn">搜索</Button>
            <Button type="primary" @click="editModal('', 'post', '新增')" class="search-btn">新增</Button>
          </div>
          <Spin size="large" fix v-if="spinShow"></Spin>
          <Table v-loading.fullscreen.lock="fullscreenLoading" height="600" size="small" border
                 :columns="columns" :data="tableData"></Table>
          <div style="margin: 10px; overflow: hidden">
            <div style="float: left;">
              <Page :total="pageTotal" :current="pageNum" :page-size="pageSize" :page-size-opts=[15,35,50,100]
                    show-sizer show-total @on-change="changePage" @on-page-size-change="handlePageSize">
              </Page>
            </div>
          </div>
          <Modal v-model="modalMap.modalVisible" :title="modalMap.modalTitle" :loading=true :footer-hide=true
                 :mask-closable=false width="520">
            <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
              <FormItem label="路径" prop="path">
                <Input v-model="formValidate.path" placeholder="请输入路径，如 /api/public/"></Input>
              </FormItem>
              <FormItem label="方法" prop="method">
                <Select v-model="formValidate.method" style="width:200px">
                  <Option value="ALL">ALL</Option>
                  <Option value="GET">GET</Option>
                  <Option value="POST">POST</Option>
                  <Option value="PUT">PUT</Option>
                  <Option value="DELETE">DELETE</Option>
                </Select>
              </FormItem>
              <FormItem label="描述" prop="description">
                <Input v-model="formValidate.description" placeholder="请输入描述"></Input>
              </FormItem>
              <FormItem label="状态" prop="status">
                <i-switch v-model="formValidate.status" size="large">
                  <span slot="open">开</span>
                  <span slot="close">关</span>
                </i-switch>
              </FormItem>
              <FormItem>
                <Button type="primary" @click="handleSubmit('formValidate')">提交</Button>
                <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
              </FormItem>
            </Form>
          </Modal>
        </Card>
      </i-col>
    </Row>
  </div>
</template>
<script>
import {
  getSkipPathList,
  operationSkipPath,
} from '@/api/sys/security_skip_path.js'

export default {
  data() {
    return {
      spinShow: false,
      fullscreenLoading: false,
      formValidate: {},
      searchVal: '',
      tableData: [],
      modalMap: {
        modalVisible: false,
        modalTitle: '编辑'
      },
      editModalData: '',
      pageNum: 1,
      pageTotal: 0,
      pageSize: 15,

      ruleValidate: {
        path: [
          { required: true, message: '路径不能为空', trigger: 'blur' }
        ],
        method: [
          { required: true, message: '请选择方法', trigger: 'change' }
        ]
      },
      columns: [
        {
          title: '序号',
          key: '_index',
          width: 65,
          align: 'center',
          render: (h, params) => {
            return h('span', params.index + 1 + (this.pageNum - 1) * this.pageSize);
          }
        },
        {
          title: '路径',
          key: 'path',
          align: 'center',
          minWidth: 200,
          tooltip: true
        },
        {
          title: '方法',
          key: 'method',
          align: 'center',
          width: 90
        },
        {
          title: '描述',
          key: 'description',
          align: 'center',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          width: 80,
          render: (h, params) => {
            return h('i-switch', {
              props: {
                value: params.row.status === 1 || params.row.status === true,
                size: 'large'
              },
              on: {
                'on-change': (val) => {
                  this.handleSwitchChange(params.row, val);
                }
              }
            });
          }
        },
        {
          title: '创建时间',
          key: 'create_time',
          align: 'center',
          minWidth: 160,
          tooltip: true
        },
        {
          title: '操作',
          key: 'handle',
          fixed: 'right',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h(
                'Button',
                {
                  props: { type: 'primary', size: 'small' },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.editModal(params.row, 'put', '编辑');
                    }
                  }
                },
                '编辑'
              ),
              h(
                'Button',
                {
                  props: { type: 'error', size: 'small' },
                  on: {
                    click: () => {
                      this.delData(params);
                    }
                  }
                },
                '删除'
              )
            ]);
          }
        }
      ],
    };
  },
  methods: {
    getSkipPathList(key) {
      this.spinShow = true;
      getSkipPathList(this.pageNum, this.pageSize, key).then(res => {
        if (res.data.code === 0) {
          this.pageTotal = res.data.count;
          this.tableData = res.data.data;
        } else {
          this.$Message.error(`${res.data.msg}`);
        }
        this.spinShow = false;
      });
    },
    handleSwitchChange(row, val) {
      let params = {
        id: row.id,
        status: val ? 1 : 0
      };
      operationSkipPath(params, 'put').then(res => {
        if (res.data.code === 0) {
          this.$Message.success(`${res.data.msg}`);
          this.getSkipPathList(this.searchVal);
        } else {
          this.$Message.error(`${res.data.msg}`);
          this.getSkipPathList(this.searchVal);
        }
      });
    },
    delData(params) {
      if (confirm(`确定要删除该路径白名单吗？`)) {
        operationSkipPath({ 'id': params.row.id }, 'delete').then(res => {
          if (res.data.code === 0) {
            this.$Message.success(`${res.data.msg}`);
            this.getSkipPathList(this.searchVal);
          } else {
            this.$Message.error(`${res.data.msg}`);
          }
        });
      }
    },
    editModal(paramsRow, meth, mtitle) {
      this.modalMap.modalVisible = true;
      this.modalMap.modalTitle = mtitle;
      this.editModalData = meth;
      if (paramsRow && paramsRow.id) {
        this.formValidate = {
          id: paramsRow.id,
          path: paramsRow.path || '',
          method: paramsRow.method || 'ALL',
          description: paramsRow.description || '',
          status: paramsRow.status === 1 || paramsRow.status === true
        };
      } else {
        this.formValidate = {
          id: 0,
          path: '',
          method: 'ALL',
          description: '',
          status: true
        };
      }
    },
    handleSubmit(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          const submitData = {
            id: this.formValidate.id,
            path: this.formValidate.path.trim(),
            method: this.formValidate.method,
            description: this.formValidate.description || '',
            status: this.formValidate.status ? 1 : 0
          };
          operationSkipPath(submitData, this.editModalData).then(res => {
            if (res.data.code === 0) {
              this.$Message.success(`${res.data.msg}`);
              this.getSkipPathList(this.searchVal);
              this.modalMap.modalVisible = false;
            } else {
              this.$Message.error(`${res.data.msg}`);
            }
          });
        } else {
          this.$Message.error('缺少必要参数');
        }
      });
    },
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    changePage(value) {
      this.pageNum = value;
      this.getSkipPathList(this.searchVal);
    },
    handlePageSize(value) {
      this.pageSize = value;
      this.pageNum = 1;
      this.getSkipPathList(this.searchVal);
    },
    searchinput() {
      this.pageNum = 1;
      this.getSkipPathList(this.searchVal);
    }
  },
  mounted() {
    this.getSkipPathList();
  }
}
</script>
<style lang="less" scoped>
.search-con {
  padding: 10px 0;
  .search {
    &-col { display: inline-block; width: 200px; }
    &-input { display: inline-block; width: 200px; margin-left: 2px; }
    &-btn { margin-left: 2px; }
  }
}
</style>